export default `
    <div class="z-list-box-wrapper #= data.containerClasses || "" #">        
        <div id="#= data.id || "" #" class="z-list-box-container #: data.classes || "" # #=data.bsc||""#" screenentitytype="#= data.ScreenEntityType #" style="#=data.style || ""#">
            <label id="NotSelectedLabel" class="label-one" for="#= data.notSelectedId #">#= data.notSelectedLabel #</label>
            <label id="SelectedLabel" class="label-two" for="#= data.selectedId #">#= data.selectedLabel #</label>
            <br />
            <select id="#= data.notSelectedId #"></select>
            <select id="#= data.selectedId #"></select>
        </div>
    </div>
`;
